import { Link } from 'react-router-dom';
import { articles, hotRank } from '@/mocks/articles';
import { formatHeat } from '@/utils/format';

const HotRankPanel = () => {
  const rankArticles = hotRank
    .map((item) => articles.find((article) => article.id === item.id))
    .filter((item): item is (typeof articles)[number] => Boolean(item));

  return (
    <aside className="lg:sticky lg:top-24" aria-labelledby="rank-heading">
      <div className="rounded-lg border border-background-200/70 bg-background-100/60 p-5 md:p-6">
        <div className="mb-4 flex items-center justify-between">
          <h2 id="rank-heading" className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <i className="ri-fire-fill text-xl text-primary-500"></i>
            今日热榜
          </h2>
          <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-[11px] text-primary-700">
            09:00 更新
          </span>
        </div>

        <ol className="space-y-3">
          {rankArticles.map((article, index) => (
            <li key={article.id} className="flex items-start gap-3">
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                  index < 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-700'
                }`}
              >
                {index + 1}
              </span>
              <div className="min-w-0">
                <Link
                  to={`/article/${article.id}`}
                  className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 hover:text-primary-600"
                >
                  {article.title}
                </Link>
                <p className="mt-1 flex items-center gap-3 text-[11px] text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatHeat(article.heat)}
                  </span>
                  <span>{article.topicName}</span>
                </p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-5 rounded-md bg-accent-100/70 p-4">
          <p className="flex items-center gap-1.5 text-xs font-medium text-accent-900">
            <i className="ri-shield-check-line text-sm"></i>
            内容核实说明
          </p>
          <p className="mt-2 text-xs leading-relaxed text-accent-900/85">
            每条爆料至少经过两次独立信源比对，无法确认的部分会标注「待验证」，不当作事实发布。
          </p>
        </div>
      </div>
    </aside>
  );
};

export default HotRankPanel;